
import { Card, Row, Col, Input, Button, Modal, Checkbox, Upload, Table, Image, Form, Tag, Popover, Select } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import { fetchData, sendData } from '../../httpRequests';
import PropTypes from 'prop-types'

// import img from "../../assets/images"
export const ScreenPlans = ({ form, selectedPlan }) => {
    const [isModalVisiblePlans, setIsModalVisiblePlans] = useState(false);
    const [plans, setPlans] = useState([])

    useEffect(() => {
        getPlans()
    }, [])

    const getPlans = () => {
        const url = '/plans/getPlans';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const plans = response['plans'];
                setPlans(plans)
            }
        })
    }

    const handleCancel = () => {
        setIsModalVisiblePlans(false)
    }
    // open modal
    const openModal = () => {
        setIsModalVisiblePlans(true)
    }

    const clickPlan = (e)=>{
        selectedPlan(e)
        setIsModalVisiblePlans(false)
    }

    return (
        <div>

            {/* <Button
                onClick={openModal}
                htmlType="submit"
                type='primary'
                size='large'
                style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                disabled={form.name == ''}
            >
                Select plans
            </Button> */}
            {/* <div onClick={openModal}> Select plans</div> */}
            <Button onClick={openModal} type="dashed"><b style={{color:'red'}}>* </b> Select plans</Button>
            <Modal 
                visible={isModalVisiblePlans}
                onCancel={handleCancel}
                width="100%"
                footer={null}
                closable={true}
                // style={{background:"#34BEAD"}}
                // bodyStyle={{ background: 'linear-gradient(to right, #34BEAD, #0f9b0f)'}}
            >
                <div style={{fontSize:'30px'}}>Usa el medio de pago que prefieras:
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Former_Visa_%28company%29_logo.svg/1280px-Former_Visa_%28company%29_logo.svg.png" alt="" width={100} /> 
                <img src="https://www.moneybob.com/wp-content/uploads/mastercard_espana.jpg" alt="" width={100} height={75} /> 
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOAAAADgCAMAAAAt85rTAAAAclBMVEUAAAD3+Pk8PDweHh7////6+/zy8/Pa29y8vL0JCQlzdHQTExOVlZbW1tcFBAXKy8zn6Omur7BJSUkZGRl5eXqkpaVgYGDJysvl5ufu7/AiIiJeXl6rrKyen6CDg4SKiotPT09pamo1NTUqKipAQUHBwcKNhVyWAAAEWklEQVR4nO2b61riMBRFW0yKg1YRlUu5qaPv/4rTImBycpr6KWh2Z68/Km2Ts0xoN2nJJoNes8zus14zyC5+u4TzQkF0KIgOBdGhIDoURIeC6FAQHQqiQ0F0KIgOBdGhIDoURIeC6FAQHQqiQ0F0KIgOBdGhIDoURIeC6FAQHQqiQ0F0KIgOBdGhIDoURIeC6FAQHQqiQ0F0KIgOBdGhIDoURIeC6FCwjYfLYVEsyseJ/3JVv/oVFtP64OlY2TLz2i+1g4fVyQWvC2NtnltrTPnkbrgz+Zewi/rgsVW2mK3b/lDd5e7UgnNHw5pHZ8utVsBnKOqDC22Due4UtJenFpx53RhnFvVE8NmfiM4U6YNg09rC78c890hwbeojHv0h3J0i+iJYmHWWvYiTpXnojeDI2HH9o/Q7smVvBGsDs8yyjRzCvz0RrMy+PVnGuieC62bkbP3LpZij454I7tJUk56e5Byd9kJwudOyw/rXuRjCt14Ivr23b17rvC2H8FuCNhHBvZRdZdm9FNz2QHB7kGrKmYk52szb7M+XSULw2LwZBYk7N5PuBuL8uuDrUcne1n8uRDeRj52f49cF7z5aN1WQuPNcO+ZqWCoMp0kKFn63rYnbEzRWoZni6QmO3IWKcdjbbt6GgmrVSQp6l4BY4j6poHWXfM4qWJmgUVn2+gyCef70Q4Jr8Sk+CxP3IjzqBILmQHVeQbFqaTatifvEgkePi7MKLkWlu+QyVhM3pqCYjrmdZ22JG1NQFroL15WauCEFt7JQu3v5VkvckIKy5f3brTNxowhOghm6P2F2JW4UwZUcwMMlb9WRuFEEgwoPoWXQkbhBBEfBDD3Gzo7EDSIol1ocjY7EjSEoL3feRJSb/MSNISgDi3cqaVnjhhIMng4onI3xxA0hKHN2XaD7KTSauCE+Lsmc3bR56HQQTmB7YkF3RpxHMLJa3QxlJbZ7ifv7SxYrd5ezCAY526V5N8YSN8Kik9rosf/neOIGEHyNDWBuZ2FlbuIGEJQ5W7ZeRRM3gGBU770AOchO/ekLBjlbtq6tcZfHw9MX7LylaZ5iiTt5QXmRa2leVnVM3MkLhjk7JIuscScvqD6FK0rYhHG1uTcDIRjmbKX92Bp36oJKzlZq0BL3DYbgp54KiSXuxAXl6T+3agfNKaUlcScuGKxnz1+ym5CrGyVxvwIIBjlbuQHYVt4+cact2Lqere4sVAoAQdmjdhP+oyk1cSctGFnP1lDXuJMWnMkZWrbvm7Uk7qQFS3lt0x5lcpC7vzQv6oLqyerHv5w1WRiP8BEDnzd/9/c37MaaEP1f/pwru/o3c+bKHmYeeefwC5LoUBAdCqJDQXQoiA4F0aEgOhREh4LoUBAdCqJDQXQoiA4F0aEgOhREh4LoUBAdCqJDQXQoiA4F0aEgOhREh4LoUBAdCqJDQXQoiA4F0aEgOhREh4LoUBAdCqJDQXQoiA4F0aEgOv+B4MtFn7mf/AOtnVNt7teF0wAAAABJRU5ErkJggg==" alt="" width={100} height={75}/> 
                <img src="https://brandemia.org/sites/default/files/inline/images/american_express_logo_wordmark_detail.png" alt="" width={100} height={60} /> 
               
              
                </div>
                {/* <img src="../../assets/images/ATH.png" alt="aqui" /> */}
                
                <div className="">

                    <div className='ModalBody' >
                        {plans.map((p) => (
                            <div span={8} key={p.id} className='plans' onClick={()=>{clickPlan(p)}}>
                                <div className='Plogo'>

                                </div>
                                <div className='pName'>
                                    <div> {p.name}</div>
                                </div>
                                <div>
                                    <p className='pPrice'><b style={{color:'green'}}>$</b>{p.price}</p>
                                </div>
                                <div className='pText'>
                                    <p>{p.description}</p>
                                </div>
                                <div style={{textAlign:'center'}}>
                                    <Button
                                        type='primary'
                                        size='large'
                                        style={{ backgroundColor: '#128780', width: '70%', borderRadius: 5, marginTop:'10px', marginBottom:'20px' }}
                                    >
                                        <SaveOutlined />
                                        Select plans
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>


            </Modal>
        </div>
    )

}
ScreenPlans.propTypes = {
    form: PropTypes.object,
    selectedPlan:PropTypes.func
}
